import type { ReactNode } from 'react';

// Рз1: one own icon per section of the tracker menu (the library set has no settings / people / projects).

function icon(body: ReactNode): ReactNode {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" className="jui-icon">
      {body}
    </svg>
  );
}

export const NAV_ICONS: Record<string, ReactNode> = {
  // columns: tasks as a board and a list
  tasks: icon(<><rect x="3" y="4" width="5" height="16" rx="1" /><rect x="10" y="4" width="5" height="10" rx="1" /><rect x="17" y="4" width="4" height="13" rx="1" /></>),
  // flag
  epics: icon(<><path d="M5 21V4" /><path d="M5 4h12l-2 4 2 4H5" /></>),
  // speech bubble with a question
  questions: icon(<><path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z" /><path d="M10 10a2 2 0 1 1 3 1.7c-.6.4-1 .8-1 1.3" /><path d="M12 16h.01" /></>),
  // cursor path of a recorded session
  ux: icon(<><path d="M5 4l6 15 2.2-6.2L19.5 11z" /><path d="M14 14l5 5" /></>),
  // sliders: the project's own settings
  project: icon(<><path d="M4 7h10" /><path d="M18 7h2" /><circle cx="16" cy="7" r="2" /><path d="M4 17h2" /><path d="M10 17h10" /><circle cx="8" cy="17" r="2" /></>),
  // grid of projects
  registry: icon(<><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" /></>),
  // sparkle
  news: icon(<><path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z" /><path d="M19 17v4" /><path d="M17 19h4" /></>),
};
